import { ClipboardEvent, useCallback } from 'react';
import { Form } from 'react-bulma-components';
import FeedbackMessage from '../../../ui/feedback-message/feedback-message';
import {
  MoveDevicesFormBlurEvent,
  MoveDevicesFormChangeEvent,
  MoveDevicesFormData,
  validateForm,
} from '../form';

export const GROUP_CODE_LENGTH = 6;
const onlyDigitsRegex = /^\d*$/;

export type MoveDevicesGroupCodeLayoutProps = {
  formData: MoveDevicesFormData;
  setFormData: (value: React.SetStateAction<MoveDevicesFormData>) => void;
};

export function MoveDevicesGroupCodeLayout({
  formData,
  setFormData,
}: MoveDevicesGroupCodeLayoutProps) {
  const onInputChange = useCallback(
    (event: MoveDevicesFormChangeEvent) => {
      const newValue = event.target.value;
      const name = event.target.name as keyof MoveDevicesFormData;
      const isOnlyDigits = onlyDigitsRegex.test(newValue);
      if (isOnlyDigits) {
        setFormData({
          ...formData,
          [name]: { ...formData[name], value: newValue, touched: true },
        });
      }
    },
    [formData, setFormData]
  );

  const onBlur = useCallback(
    (event: MoveDevicesFormBlurEvent) => {
      const value = event.target.value;
      const name = event.target.name as keyof MoveDevicesFormData;
      const error = validateForm[name]?.(value);
      setFormData({
        ...formData,
        [name]: {
          ...formData[name],
          error,
        },
      });
    },
    [formData, setFormData]
  );

  const onPasteGroupCode = useCallback(
    (event: ClipboardEvent<HTMLInputElement>) => {
      event.preventDefault();
      const pasteData = event.clipboardData.getData('text');
      const filteredData = pasteData.replace(/\D/g, '');
      if (filteredData) {
        setFormData({
          deviceGroupCode: {
            ...formData.deviceGroupCode,
            value: filteredData,
            touched: true,
          },
        });
      }
    },
    [formData.deviceGroupCode, setFormData]
  );

  return (
    <Form.Control>
      <Form.Field>
        <Form.Label
          htmlFor="deviceGroupCode"
          className="is-size-7 has-text-weight-normal"
        >
          Group code
        </Form.Label>
        <Form.Control display="flex" flexDirection="row" className="gap-4">
          <Form.Input
            id="deviceGroupCode"
            placeholder="------"
            maxLength={GROUP_CODE_LENGTH}
            name="deviceGroupCode"
            value={formData.deviceGroupCode.value}
            onChange={onInputChange}
            onBlur={onBlur}
            onPaste={onPasteGroupCode}
          />
        </Form.Control>
      </Form.Field>

      <FeedbackMessage>{formData.deviceGroupCode.error}</FeedbackMessage>
    </Form.Control>
  );
}

export default MoveDevicesGroupCodeLayout;
